(function () {
  'use strict';
  var cfg = window.YD_CART || {};
  var drawer = document.getElementById('yd-drawer');
  if (!drawer) return;
  var scrim = document.getElementById('yd-scrim');
  var linesEl = document.getElementById('yd-lines');
  var footEl = document.getElementById('yd-foot');
  var lastFocus = null;

  function money(cents) {
    var f = cfg.moneyFormat || '${{amount}}';
    var n = (cents / 100);
    function fixed(v, d, thou, dec) {
      var s = v.toFixed(d).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return s.join(dec);
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return fixed(n, 0, ',', '.');
        case 'amount_with_comma_separator': return fixed(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fixed(n, 0, '.', ',');
        default: return fixed(n, 2, ',', '.');
      }
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(url) {
    if (!url) return 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    return url.replace(/(\.[a-z]+)(\?|$)/i, '_128x128$1$2');
  }
  function json(url, opts) {
    opts = opts || {};
    opts.credentials = 'same-origin';
    opts.headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw d; return d; });
    });
  }

  function render(cart) {
    var html = '';
    cart.items.forEach(function (it, i) {
      var n = i + 1;
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="yd-var">' + esc(it.variant_title) + '</div>' : '';
      html += '<div class="yd-line">' +
        '<a href="' + esc(it.url) + '"><img src="' + esc(img(it.image)) + '" alt="' + esc(it.product_title) + '"></a>' +
        '<div><h3><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></h3>' + variant +
        '<div class="yd-qty"><button type="button" data-yd="dec" data-line="' + n + '" data-qty="' + (it.quantity - 1) + '" aria-label="\u2212">\u2212</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-yd="inc" data-line="' + n + '" data-qty="' + (it.quantity + 1) + '" aria-label="+">+</button></div>' +
        '<button type="button" class="yd-rm" data-yd="rm" data-line="' + n + '" aria-label="' + esc(cfg.removeText) + '">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg></button></div>' +
        '<div class="yd-price">' + money(it.line_price) + '</div></div>';
    });
    linesEl.innerHTML = html || '<div class="yd-empty"><p>' + esc(cfg.emptyText) + '</p><a href="/collections/all">' + esc(cfg.continueText) + '</a></div>';
    footEl.hidden = !cart.items.length;
    document.getElementById('yd-total').textContent = money(cart.total_price);
    document.getElementById('yd-badge').textContent = cart.item_count;
    [].forEach.call(document.querySelectorAll('.cartCount'), function (el) { el.textContent = cart.item_count; });
    linesEl.classList.remove('is-busy');
  }

  function refresh() { return json('/cart.js').then(render); }

  function open() {
    lastFocus = document.activeElement;
    scrim.hidden = false;
    requestAnimationFrame(function () {
      scrim.classList.add('is-on');
      drawer.classList.add('is-open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('yd-lock');
    setTimeout(function () { document.getElementById('yd-close').focus(); }, 60);
  }
  function close() {
    scrim.classList.remove('is-on');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('yd-lock');
    setTimeout(function () { scrim.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function addToCart(form) {
    var btn = form.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    return json('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(refresh).then(open)
      .catch(function (err) {
        // Fall back to the normal form post so the shopper sees Shopify's error page.
        form.submit();
      })
      .then(function () { if (btn) btn.disabled = false; });
  }

  // Intercept add-to-cart forms before the theme's own handlers run.
  function isAddForm(f) { return f && f.tagName === 'FORM' && /\/cart\/add/.test(f.getAttribute('action') || ''); }
  document.addEventListener('submit', function (e) {
    if (!isAddForm(e.target)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    addToCart(e.target);
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('input[type=submit],button[type=submit]');
    if (!b || !isAddForm(b.form) || b.disabled) return;
    e.preventDefault(); e.stopImmediatePropagation();
    addToCart(b.form);
  }, true);

  // Header cart link opens the drawer instead of the old dropdown.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.cartToggle, a[href="/cart"].cart-link');
    if (!t) return;
    e.preventDefault(); e.stopImmediatePropagation();
    refresh().then(open);
  }, true);

  // Drawer controls
  document.getElementById('yd-close').addEventListener('click', close);
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
  linesEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-yd]');
    if (!b) return;
    var q = b.dataset.yd === 'rm' ? 0 : Math.max(0, parseInt(b.dataset.qty, 10));
    linesEl.classList.add('is-busy');
    json('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(b.dataset.line, 10), quantity: q })
    }).then(render).catch(refresh);
  });

  refresh();
})();
